export enum viewerDrawerTypeEnum {
    Notes,
    Markups,
    Bookmarks
}